import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Hooks } from '@grandvisionhq/payments';
import { useCreatePaymentRequest } from '../../modules/ExpressCheckout/hooks/apple-pay/helper-hooks/use-create-payment-request.js';
import { useHandleOrderCreation } from './useHandlerOrderCreation.js';
import { useValidateAndSetOrderDetails } from './useValidateAndSetOrderDetails.js';

const useHandleApplePay = ({ selfUrl , donationInfo , consents: consents1 , isSaveDetailsInAccount =false , setIsOrderInProgress ,  })=>{
    const [createPaymentRequest] = useCreatePaymentRequest(false);
    const [payCartWithApplePayActions] = Hooks.useApplePayWithActions();
    const { handlePlaceOrder  } = useHandleOrderCreation();
    const { handleOrderDetailsValidation , saveCustomerInformationWithoutValidation  } = useValidateAndSetOrderDetails();
    const createApplePayOrder = React.useCallback(function() {
        var _ref1 = swcHelpers.asyncToGenerator(function*({ paymentToken , selectedPaymentMethod  }) {
            setIsOrderInProgress(true);
            yield saveCustomerInformationWithoutValidation().then(function() {
                var _ref = swcHelpers.asyncToGenerator(function*({ success  }) {
                    if (!success) {
                        setIsOrderInProgress(false);
                        return;
                    }
                    yield handlePlaceOrder({
                        selectedPaymentMethod,
                        paymentDetails: {
                            isValid: true,
                            type: selectedPaymentMethod.type,
                            data: {
                                applePayToken: paymentToken
                            }
                        },
                        selfUrl,
                        consents: consents1,
                        donationInfo,
                        isSaveDetailsInAccount,
                        setIsOrderInProgress
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }());
        });
        return function(_) {
            return _ref1.apply(this, arguments);
        };
    }(), [
        setIsOrderInProgress,
        saveCustomerInformationWithoutValidation,
        handlePlaceOrder,
        selfUrl,
        consents1,
        donationInfo,
        isSaveDetailsInAccount, 
    ]);
    const payWithApplePay = React.useCallback(({ selectedShippingMethod , consents  })=>{
        if (selectedShippingMethod.method && handleOrderDetailsValidation(selectedShippingMethod, consents)) {
            try {
                payCartWithApplePayActions({
                    createPaymentRequest,
                    completePayment: createApplePayOrder
                });
            } catch (error) {
                console.error('payWithApplePay: Payment initialisation error', error);
                return;
            }
        } else {
            toast.failed('checkout.errors.form.general');
        }
    }, [
        createApplePayOrder,
        createPaymentRequest,
        handleOrderDetailsValidation,
        payCartWithApplePayActions, 
    ]);
    return {
        payWithApplePay
    };
};

export { useHandleApplePay };
//# sourceMappingURL=useHandleApplePay.js.map
